import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ThankYou = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Clear cart on successful payment
    // This would typically be handled by the webhook
  }, [sessionId]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 container mx-auto px-4 py-12 flex items-center justify-center">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-white rounded-lg shadow-2xl p-12">
            {/* Success Icon */}
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>

            <h2 className="text-4xl font-bold mb-4" style={{color: '#2C7A9F'}}>
              Thank You for Your Purchase!
            </h2>
            
            <p className="text-xl text-gray-700 mb-6">
              Your order has been successfully processed.
            </p>

            <div className="bg-gradient-to-r from-teal-50 to-purple-50 rounded-lg p-6 mb-8">
              <h3 className="font-bold text-lg mb-3" style={{color: '#3D2817'}}>
                What Happens Next?
              </h3>
              
              <div className="space-y-3 text-left">
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0" style={{backgroundColor: '#D4A948'}}>
                    <span className="text-white font-bold">1</span>
                  </div>
                  <p className="text-gray-700 pt-1">
                    <strong>Confirmation Email:</strong> Check your inbox for order confirmation and receipt
                  </p>
                </div>

                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0" style={{backgroundColor: '#8B3A9B'}}>
                    <span className="text-white font-bold">2</span>
                  </div>
                  <p className="text-gray-700 pt-1">
                    <strong>Digital Products:</strong> Your downloads are being prepared and will arrive shortly
                  </p>
                </div>

                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0" style={{backgroundColor: '#2C7A9F'}}>
                    <span className="text-white font-bold">3</span>
                  </div>
                  <p className="text-gray-700 pt-1">
                    <strong>Support:</strong> Contact us at info@coloursandsquares.co.uk if you need assistance
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t-2 border-gray-200 pt-6">
              <p className="text-gray-600 mb-4">
                We've also sent a copy of your order to our team.
              </p>
              {sessionId && (
                <p className="text-sm text-gray-500 mb-6">
                  Order ID: {sessionId.substring(0, 20)}...
                </p>
              )}
            </div>

            <button
              onClick={() => navigate('/')}
              className="px-8 py-4 rounded-lg font-bold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition"
              style={{backgroundColor: '#2C7A9F'}}
              data-testid="back-to-home-button"
            >
              Back to Home
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ThankYou;